<template>
  <div>
    <ViewHeader>
      <CButton
        color="primary"
        class="ra-button"
        @click="editId = 'create'"
        data-cy="create-label"
      >
        Create label
      </CButton>
    </ViewHeader>

    <tableComponent
      class="labels-table"
      :data="labels"
      :columns="[...columns, ...adminColumns]"
      :headings="{
        Open: 'Open ticket',
        Closed: 'Closed ticket',
      }"
      :sort-exclude-columns="adminColumns"
      :filter-exclude-columns="adminColumns"
    >
      <template #actions="{ row }">
        <div class="d-flex gap-2">
          <CButton
            @click="triggerLabelEditModal(row)"
            class="ra-icon-button"
            v-c-tooltip="'Edit label'"
          >
            <Icon name="pencil" />
          </CButton>
          <CButton
            class="ra-icon-button"
            v-c-tooltip="'Delete label'"
            @click="() => deleteLabel(row)"
            data-cy="delete-label"
          >
            <Icon name="trash" />
          </CButton>
        </div>
      </template>

      <template v-for="status in ['Open', 'Closed']" #[status]="{ row }">
        <CLink
          :to="{
            name: 'List of tasks',
            query: { tab: status, search_label: row.name },
          }"
        >
          {{ $getNumericalValue(row[status], 0, 0) }}
        </CLink>
      </template>
    </tableComponent>
    <RaModal
      :canConfirm="canCreate"
      :show="!!editId"
      @confirm="() => saveLabel()"
      @cancel="() => saveLabel(false)"
      title="Edit label"
      size="sm"
    >
      <RaInput
        size="sm"
        class="filter-input mb-5"
        v-model="newLabelName"
        v-if="editId"
        data-cy="label-input"
      />
    </RaModal>
  </div>
</template>

<script>
import { LABELS_ENDPOINTS, LabelsService } from "@/services/labels";
import { ActiveUser } from "@/services/user";

export default {
  name: "LabelManagement",
  data() {
    return {
      LABELS_ENDPOINTS,
      columns: ["name", "Open", "Closed"],
      adminColumns: [],
      editId: null,
      newLabelName: "",
      canCreate: true,
      labels: [],
    };
  },
  mounted() {
    if (ActiveUser.isAdministrator()) this.adminColumns = ["actions"];
    this.fetchLabels();
  },
  watch: {
    async newLabelName(newVal) {
      if (newVal !== '') {
        this.canCreate = ! await LabelsService.isUnique(newVal)
        if (!this.canCreate) alert(`Label ${newVal} already exists`, {color: "warning"});
      }
    }
  },
  methods: {
    async fetchLabels() {
      this.labels = (await LabelsService.getLabels()).map((l) => ({
        _id: l._id,
        name: l.name,
        Closed: l.tickets_meta.Closed,
        Open: l.tickets_meta.Open,
      }));
    },
    triggerLabelEditModal(row) {
      this.editId = row._id;
      this.newLabelName = row.name;
    },
    async saveLabel(accept = true) {
      if (accept && this.newLabelName) {
        await LabelsService.editOrCreateLabel(this.editId, {
          name: this.newLabelName,
        });
      }
      this.editId = null;
      this.newLabelName = "";
      await this.fetchLabels();
    },
    async deleteLabel(row) {
      if (!(await confirm(`Are you sure you want to delete ${row.name}?`))) {
        return;
      }
      await LabelsService.deleteLabel(row._id);
      await this.fetchLabels();
    },
  },
};
</script>
